import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-separator',
  templateUrl: './separator.component.html',
  styleUrls: ['./separator.component.scss'],
})
export class SeparatorComponent {
  @Input() text: string;

  constructor() {}
}
